export const colors = [{
    texture: './public/textures/cybertruck_rubber.png',
    size: [1, 1, 1],
    shininess: 0,
    sections: ['tires'],
  },
  {
    texture: './public/textures/glass.png',
    size: [1, 1, 1],
    shininess: 0,
    sections: ['glass', 'lights', 'gray', 'interior'],
  },
  {
    color: 'f0e289',
    sections: ['body'],
    metallic: true,
    roughness: 0.5
  },
  // {
  //     color: '555555',
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  //     metallic: true,
  //     roughness: 0
  // },
  // {
  //     color: 'ffffff',
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  //     metallic: true,
  //     roughness: 0
  // },

  // {
  //     texture: 'sunburst.jpg',
  //     color: 'ffffff',
  //     size: [1, 1, 1],
  //     shininess: 600,
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //     texture: 'blue-sunburst.jpg',
  //     color: 'ffffff',
  //     size: [1, 1, 1],
  //     shininess: 600,
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //     texture: 'silver-sunburst.jpg',
  //     color: 'ffffff',
  //     size: [1, 1, 1],
  //     shininess: 600,
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //     color: '131417',
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  //     shininess: 1000,
  // },
  // {
  //     color: '97a1a7',
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //     color: 'acb4b9',
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //     color: 'DF9998',
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //     color: '7C6862',
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //     color: 'A3AB84',
  //     sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'D6CCB1',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'F8D5C4',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'A3AE99',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'EFF2F2',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'B0C5C1',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '8B8C8C',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '565F59',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'CB304A',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'FED7C8',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'C7BDBD',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '3DCBBE',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '264B4F',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '389389',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '85BEAE',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'F2DABA',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'F2A97F',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'D85F52',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'D92E37',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'FC9736',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'F7BD69',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'A4D09C',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '4C8A67',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '25608A',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '75C8C6',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'F5E4B7',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'E69041',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'E56013',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '11101D',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '630609',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'C9240E',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'EC4B17',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '281A1C',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '4F556F',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '64739B',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: 'CDBAC7',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '946F43',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '66533C',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '173A2F',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: '153944',
  //   sections: ['legs', 'base', 'back', 'supports', 'cushions'],
  // },
  // {
  //   color: "ff0000",
  //   sections: ["no-product"],
  //   size: [3, 3, 3]
  // },
];